import axios from 'axios'  //引入axios
//下面这两个不一定需要引入，看你项目需要拦截的时候做什么操作，
import store from '@/store/index'  //引入store
import router from '@/router'  //引入router

let apiAxios = axios.create({
    // headers: {
    // //   'content-type': 'application/x-www-form-urlencoded'
    // }
  })
// http request 拦截器
apiAxios.interceptors.request.use(
    config => {
      const token = sessionStorage.getItem('token')
      if (token ) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.authorization = token  //请求头加上token
      }
      return config
    },
    err => {
      return Promise.reject(err)
    })
// http response 拦截器
apiAxios.interceptors.response.use(
    response => {
      //拦截响应，做统一处理 
      if (response.data.code) {
        let rcode = response.data.code;
        //后台0002 和 0003 都按token失效处理，跳转到登录页
        if(rcode == "0002" || rcode == "0003") rcode = "0002";
        switch (response.data.code) {
          case '0002':
            store.state.isLogin = false
            router.replace({
              path: 'login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
        }
      }
      return response
    },
    //接口错误状态处理，也就是说无响应时的处理
    error => {
      return Promise.reject(error.response.status) // 返回接口返回的错误信息
    })

 export default apiAxios;